<template>
  <div>
    <el-row style="margin-top:20px">
      <el-form ref="searchForm" style="margin: 10px 0 15px 0;" size="medium" inline>
        <el-form-item>
          <el-checkbox label="查看已读" v-model="readStatus" @change="刷新()"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-tooltip class="item" effect="dark" content="请先勾选要切换的记录" placement="bottom" :disabled="Boolean(checkedList.length)">
            <div style="display: inline-block;">
              <el-button @click="batchChangeReadStatus" v-preventReClick :disabled="!checkedList.length">
                {{ readStatus ? '标记为未读' : '标记为已读' }}
              </el-button>
            </div>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-button type="button" @click="刷新()" v-preventReClick>刷 新</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-col>
        <el-table :data="tableData" ref="tableData" stripe border style="width: 100%" max-height="520px" @selection-change="selectionChange">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="READ_STATUS" label="处理状态" min-width="60">
            <template slot-scope="scope">
              <span>{{ ['未读', '已读'][scope.row.READ_STATUS] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="CREATE_TIME" label="时间" min-width="60"></el-table-column>
          <el-table-column prop="TITLE" label="任务内容" min-width="60">
            <template slot-scope="scope">
              <span>{{ scope.row.TITLE }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="STATUS" label="任务状态" min-width="110">
            <template slot-scope="scope">
              <span>{{ statusList[scope.row.STATUS] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="COMMENT" label="备注" min-width="110"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="downloadFile(scope.row)" v-if="scope.row.STATUS == 2" v-preventReClick>
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="height: 50px; margin-top: 10px;">
          <el-pagination :current-page.sync='currentPage' :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalCount"
            style="float: right;" @current-change='queryData()'>
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      readStatus: false,
      tableData: [],
      currentPage: 1,
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      statusList: ['失败', '进行中', '成功', '进行中'],
      checkedList: [],
      appointmentOperationList: [
        { id: 0, name: '未定义' },
        { id: 1, name: '历史价格导出' },
      ],
    };
  },
  methods: {
    刷新() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '100631',
        OTYPE: 1,
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
        READ_STATUS: Number(this.readStatus),
      };
      http.post(params).then((res) => {
        this.tableData = res[0].LIST;
        this.totalCount = res[0].TOTAL_COUNT;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    changeReadStatus(ID) {
      const params = {
        SERVICE_ID: '100631',
        OTYPE: 2,
        ID,
        READ_STATUS: Number(!this.readStatus),
      };
      return http.post(params);
    },
    async batchChangeReadStatus() {
      const resList = [];
      const errList = [];
      try {
        for (const item of this.checkedList) {
          resList.push(await this.changeReadStatus(item.ID));
          if (this.readStatus) this.$store.commit('ADD_TO_UNREAD_INFORMATION_LIST', item);
          else this.$store.commit('DELETE_FROM_UNREAD_INFORMATION_LIST', item);
        }
      } catch (err) {
        errList.push(err);
      } finally {
        if (!errList.length) {
          this.$message.show({ text: '切换成功', type: 'success' });
          this.queryData();
        } else {
          this.$message.show({ text: '切换失败', type: 'warning' });
          // eslint-disable-next-line no-console
          console.log('errList', errList);
        }
      }
    },
    downloadFile(row) {
      window.location.href = this.$util.getURLLocalHost(row.RESULT);
      if (!row.READ_STATUS) {
        this.changeReadStatus(row.ID).then((res) => {
          if (!this.readStatus) this.$store.commit('DELETE_FROM_UNREAD_INFORMATION_LIST', row);
          this.queryData();
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
      }
    },
    getAppointmentOperation(index) {
      return util.appointmentOperationList.find((item) => item.id == index).name;
    },
    selectionChange(val) {
      this.checkedList = [...val];
    },
  },
  created() {
    this.queryData();
  },

};

</script>

<style scoped>
.middle {
  height: 20px;
  background-color: #f5f7f9;
  padding: 0 40px;
}

.searchForm {
  background: white;
  border-radius: 3px;
  padding: 10px 20px 0 20px;
  height: 66px;
}

.el-form {
  height: 36px;
}

.container {
  font-size: 14px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/base/appointmentHandling.vue